(function(){
  var B={
    "fem-cycle":"Équilibre féminin et vitalité dès 40 ans",
    "calm-ritual":"Sérénité et sommeil, votre rituel du soir",
    "inner-flora":"Microbiote, confort digestif et intime",
    "pack-rituel-complet":"Le trio complet, 15 % d'économie"
  };
  function ho(a){
    var h=a.getAttribute("href")||"";
    var i=h.indexOf("/products/");
    if(i<0)return "";
    h=h.slice(i+10).split("/")[0].split("?")[0].split("#")[0];
    return h;
  }
  function inj(){
    var L=document.querySelectorAll('a[href*="/products/"]');
    for(var k=0;k<L.length;k++){
      var a=L[k];
      var card=a.closest(".product-card-group");
      if(!card)continue;
      if(card.querySelector(".auraa-card-benefit"))continue;
      var t=B[ho(a)];
      if(!t)continue;
      var ti=card.querySelector("h2,h3");
      if(!ti||!ti.parentNode)continue;
      var d=document.createElement("div");
      d.className="auraa-card-benefit";
      d.textContent=t;
      d.style.cssText="font-size:13px;line-height:1.35;color:#4A4DB5;margin:4px 0 6px;font-weight:500;letter-spacing:.2px;";
      ti.parentNode.insertBefore(d,ti.nextSibling);
    }
  }
  function boot(){ if(document.readyState!=="loading"){inj();} }
  boot();
  document.addEventListener("DOMContentLoaded",inj);
  var c=setInterval(inj,700);
  setTimeout(function(){clearInterval(c);},6000);
})();
(function(){
  if(location.pathname.indexOf("/products/pack-rituel-complet")<0) return;
  function fp(){
    var n=document.querySelectorAll(".product-section__product-info p, .product-section__product-info span, .product-section__product-info li, .product-section__product-info strong");
    for(var i=0;i<n.length;i++){var el=n[i];if(el.children.length!==0)continue;var t=(el.textContent||"").trim();if(/^1\s*pot\s*=\s*1\s*mois de cure/i.test(t)){el.textContent="3 cures de 1 mois : FEM CYCLE, CALM RITUAL et INNER FLORA";}}
  }
  if(document.readyState!=="loading"){fp();}
  document.addEventListener("DOMContentLoaded",fp);
  var pc=setInterval(fp,600);setTimeout(function(){clearInterval(pc);},5000);
})();
